// CookiePolicyPage.jsx
import React from 'react';
import './LeaderBoard.css'; // CSS for styling this page (you might want to rename or create a specific CSS file for cookie policy)

const CookiePolicyPage = () => {
  return (
    <div className="terms-conditions-container"> {/* Consider renaming this class if it's too generic */}
      <div className="terms-conditions-content"> {/* Consider renaming this class */}
        <h1>Cookie Policy</h1>

        <p>
          This Cookie Policy explains how WannaPractice & iVox.ai,
          LLC. (“iVox.ai”) and its subsidiaries (collectively,
          iVox.ai Group or, “we”, “us”, and “ours”) uses cookies and
          similar technologies to recognize you when you visit any of
          our websites or subdomains of wannapractice.com or
          ivox.ai (iVox Learning) (“website”). It explains what these
          technologies are and why we use them, as well as your rights
          to control our use of them.
        </p>

        <h2>What are cookies?</h2>
        <p>
          Cookies are small data files that are placed on your device
          when you visit a website. Cookies are widely used by website
          owners in order to make their websites work, or to work more
          efficiently, as well as to provide reporting information.
          Cookies set by the website owner (in this case, iVox.ai)
          are called “first-party cookies.” Cookies set by parties
          other than the website owner are called “third-party
          cookies.” Third-party cookies enable third-party features or
          functionality to be provided on or through the website
          (e.g., such as advertising, interactive content and
          analytics). The parties that set these third-party cookies
          can recognize your device both when it visits the website in
          question and also when it visits certain other websites.
        </p>

        <h2>
          Why does WannaPractice & iVox.ai use cookies?
        </h2>
        <p>
          We use first-party and third-party cookies for several
          reasons. Some cookies are required for technical reasons in
          order for our websites to operate, and we refer to these as
          “essential” or “strictly necessary” cookies. Other cookies
          also enable us to track and target the interests of our
          visitors to enhance the experience on our website. Third
          parties place cookies on our website for advertising,
          analytics and other purposes. This is described in more
          detail below.
        </p>

        <h2>
          What types of cookies does WannaPractice & iVox.ai use?
        </h2>
        <p>
          <strong>Essential website cookies:</strong> These cookies are strictly
          necessary to provide you with services available through our
          website and to use some of its features. For example, they
          allow us to maintain secure login sessions. If you choose to
          refuse these cookies, then you may still use our website
          though your access to some functionality and areas of our
          website may be restricted.
        </p>

        <h2>Performance and functionality cookies</h2>
        <p>
          These cookies are used to enhance the performance and
          functionality of our website but are non-essential to its
          use, for example, interaction with blogs, chat rooms and
          forums and to enable us to differentiate between customers
          and guest visitors for the purposes of determining the level
          of permitted usage of certain tools made available via the
          website.
        </p>

        <h2>Analytics and customization cookies</h2>
        <p>
          These cookies collect information that are used either in
          aggregate form to help us understand how our website is
          being used or how effective our marketing campaigns are, or
          to help us customize our website for you.
        </p>

        <h2>Targeting/Advertising/Analytics cookies</h2>
        <p>
          These cookies are used to make advertising messages more
          relevant to you and your interests and track advertising
          impressions. They perform functions like preventing the same
          ad from continuously appearing, ensuring that ads are
          properly displayed for advertisers, helping measure the
          effectiveness of advertising campaigns and, in some cases,
          selecting advertisements that are based on your interests.
        </p>
        <p>
          An example of a Targeting/Advertising cookie
          that we use is the Google Analytics cookie, which is used to
          collect information about how visitors use our website. We
          link this information to personal information that you enter
          in our online forms and to your account details. We then use
          the information to understand which products and services
          you are interested in and to send you information in respect
          of those products or services.
        </p>

        <h2>Social networking cookies</h2>
        <p>
          These cookies are used to enable you to share pages and
          content that you find interesting on our website through
          third-party social networking and other websites. These
          cookies may also be used for advertising and analytics
          purposes.
        </p>
        <p>
          When you share an article using a social media
          sharing button on our website (e.g. Facebook, LinkedIn,
          Twitter, or Google+), the social network that has created
          the button will record that you have done this. Because of
          how cookies work, we cannot access these cookies nor can the
          third parties access the data in cookies used by us.
        </p>
        <p>
          See the list below for the types of first- and
          third-party cookies placed on our website and how you can
          refuse such cookies.
        </p>

        <h2>
          What about other tracking technologies, like web beacons?
        </h2>
        <p>
          Cookies are not the only way to recognize or track visitors
          to a website. We may use other, similar technologies from
          time to time like web beacons (sometimes called “tracking
          pixels” or “clear gifs”). These are tiny graphics files that
          contain a unique identifier that enable us to recognize when
          someone has visited our website. This allows us, for
          example, to monitor the traffic patterns of visitors from
          one page within our website to another, to deliver or
          communicate with cookies, to understand whether you have
          come to our website from an online advertisement displayed
          on a third-party website, to improve site performance, and
          to measure the success of outbound marketing campaigns. In
          many instances, these technologies are reliant on cookies to
          function properly, and so declining cookies will impair
          their functioning.
        </p>

        <h2>
          Does WannaPractice & iVox.ai allow targeted advertising?
        </h2>
        <p>
          Third parties may place cookies on your computer or mobile
          device to serve advertising through our website. These
          companies may use information about your visits to this and
          other websites in order to provide relevant advertisements
          about goods and services that you may be interested in. They
          may also employ technology that is used to measure the
          effectiveness of advertisements. This can be accomplished by
          third parties using cookies or web beacons to collect
          information about your visits to this and other sites in
          order to provide relevant advertisements about goods and
          services of potential interest to you. The information
          collected through this process does not enable us or such
          third parties to identify your name, contact details or
          other personally identifying details unless you choose to
          provide these (except that, as outlined above, we may
          combine certain information about your use of the website
          with personal information that you provide to us in online
          forms in order to contact you about products or services in
          which you may be interested).
        </p>

        <h2>
          How often will WannaPractice & iVox.ai update this cookie
          policy?
        </h2>
        <p>
          We may update this Cookie Policy from time to time in order
          to reflect, for example, changes to the cookies we use or
          for other operational, legal or regulatory reasons. The date
          at the top of this Cookie Policy indicates when it was last
          updated. Please re-visit this Cookie Policy regularly to
          stay informed about our use of cookies and related
          technologies.
        </p>

        <h2>Where can I get further information?</h2>
        <p>
          If you have any questions about our use of cookies or other
          technologies, then please email us at{' '}
          <a href="mailto:privacy@wannapractice.com">privacy@wannapractice.com</a>.
        </p>
        <p>
          This list illustrates the types of cookies used
          by WannaPractice & iVox.ai, who serves them, and how you
          can refuse them. See “What types of cookies does iVox.ai
          use?” above for an explanation of each type of cookie.
        </p>
        <p>
          In all cases, you can change your browser
          setting to refuse these cookies. Please visit your browser’s
          help menu for more information on how to do so.
        </p>
        <p>
          This website uses cookies. We use cookies to
          personalise content and ads, to provide social media
          features and to analyse traffic. We also share information
          about your use of our site with our social media,
          advertising and analytics partners who may combine it with
          other information that you’ve provided to them or that
          they’ve collected from your use of their services. To
          opt-in, select ok, otherwise select settings to set opt-out
          preferences.
        </p>
        <p>
          Cookies are small text files that can be used by
          websites to make a user's experience more efficient.
        </p>
        <p>
          The law states that we can store cookies on your
          device if they are strictly necessary for the operation of
          this site. For all other types of cookies we need your
          permission.
        </p>
        <p>
          This site uses different types of cookies. Some
          cookies are placed by third party services that appear on
          our pages.
        </p>
      </div>
    </div>
  );
};

export default CookiePolicyPage;